import React from 'react'
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import { useNavigate } from "react-router-dom";

import mjcLogo from '../assets/img/logo_ftr.webp'
import mmLogo from '../assets/img/mm.webp'
/* import mmDrkLogo from '../assets/img/mm_drk.webp'
import mmDevLogo from '../assets/img/mmDev.png' */

import { GrGoogle } from "react-icons/gr";

const containerStyle = {
    width: "100%",
    height: "100%",
};

const center = {
    lat: -1.2849165191816425,  // Your Latitude
    lng: 36.81934344047725,  // Your Longitude
};
// -1.2849165191816425, 36.81934344047725
// -1.2848750905693336, 36.819377549982406
//   -1.2847509434239286, 36.81953759814897

const Ftr = () => {
    const navigate = useNavigate();
    const handleClick = () => {
        navigate("/login"); // Navigate to homepage

        setTimeout(() => {
            const homeSection = document.getElementById("login");
            if (homeSection) {
                const offset = 20; // Adjust scroll offset
                const targetY = homeSection.getBoundingClientRect().top + window.scrollY - offset;

                window.scrollTo({ top: targetY, behavior: "smooth" });
            }
        }, 100); // Delay ensures the page loads before scrolling
    };
    return (
        <div className='relative w-full flex flex-col items-center bg-gradient-to-br from-primaryRichBlue to-primaryRichGreen justify-between xs:mt-[4rem] lg:mt-[6rem] pt-0 overflow-hidden border-t-[4px] border-primaryDarkBlue shadow-[inset_0px_16px_32px_rgba(0,0,0,0.35)]'>
            <div className={`footer-gradient absolute top-0 left-0 bgPtn w-full h-full z-[100] mix-blend-multiply`} />
            <div className={`footer-gradient absolute top-0 left-0 bgPtn w-full h-full z-[100] mix-blend-multiply`} />

            {/* <div className='w-full h-[1px] bg-gradient-to-r from-slate-800/0 to-slate-800/40 xs:mx-[1rem] lg:mx-[3rem]' /> */}
            <div className="grid xs:grid-cols-1 lg:grid-cols-[50%_50%] 2xl:grid-cols-[44.5%_55.5%] 4xl:grid-cols-[37.5%_62.5%] 5xl:grid-cols-[35%_65%] 6xl:grid-cols-[32.5%_77.5%] pgPdn w-full xs:py-[0.5rem] 2xl:py-[0rem] mb-[0rem]">
                <div className="leftFtr flex xs:flex-col lg:flex-row xs:items-center lg:items-center h-full w-full lg:pl-[1rem] 2xl:pr-[1rem] lg:border-r border-white/20">
                    <div>
                        <img
                            src={mjcLogo}
                            alt="MJC Logo Footer"
                            className='xs:w-[8rem] xsp:w-[9rem] md:w-[12rem] xl:w-[11rem] 2xl:w-[13rem] h-auto'
                        />
                    </div>
                    <div className="flex flex-col xs:mt-[0.5rem] xs:ml-[1rem] lg:mt-0 lg:ml-[1rem] 2xl:ml-[2rem] z-[999]">
                        <p
                            className='rennerBold uppercase xs:text-center lg:text-left xs:tracking-[2px] lg:tracking-[2px] xs:text-[0.6rem] xsp:text-[0.7rem] md:text-[0.85rem] lg:text-[0.65rem] xl:text-[0.75rem] 2xl:text-[0.85rem] text-white'
                        >
                            Murage Juma & Company Advocates
                        </p>
                        <p
                            className='rennerBold uppercase xs:text-center lg:text-left xs:tracking-[2px] lg:tracking-[2px] xs:text-[0.475rem] xsp:text-[0.55rem] md:text-[0.65rem] lg:text-[0.525rem] xl:text-[0.55rem] 2xl:text-[0.65rem] text-white/80 xs:mb-[0.5rem] lg:mb-[0.25rem]'
                        >
                            Commissioners for Oaths &amp; Notaries Public
                        </p>
                        <div>
                            <a
                                href="mailto:info@jncmlaw.co.ke"
                                target="_blank"
                                rel="noreferrer"
                                className='cursor-pointer flex flex-col whitespace-nowrap outfit tracking-[1px] ftrTxt xs:mt-[0.5rem] lg:mt-[1rem] text-white'
                            >
                                <span className='font-[700]'>Email:</span>
                                <span className='underline xs:decoration-1 underline-offset-[3px] decoration-white/50 font-[400]'>
                                    info@jncmlaw.co.ke
                                </span>
                            </a>
                            <div
                                className='flex flex-col whitespace-nowrap outfit tracking-[1px] ftrTxt text-white xs:mt-[0.5rem] lg:mt-[0.5rem]'
                            >
                                <span className='font-[700]'>Mobile:&nbsp;</span>
                                <div
                                    className='flex flex-row !font-[400]'
                                >
                                    <a
                                        href="tel:+254725562277"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className='cursor-pointer underline xs:decoration-1 underline-offset-[3px] decoration-white/50'
                                    >
                                        +254725562277
                                    </a>
                                    &nbsp;/&nbsp;
                                    <a
                                        href="tel:+254788350147"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className='cursor-pointer underline xs:decoration-1 underline-offset-[3px] decoration-white/50'
                                    >
                                        +254788350147
                                    </a>
                                </div>
                            </div>
                            <a
                                href="tel:+254202214110"
                                target="_blank"
                                rel="noopener noreferrer"
                                className='flex flex-col whitespace-nowrap outfit tracking-[1px] ftrTxt text-white xs:mt-[0.5rem] lg:mt-[0.5rem] '
                            >
                                <span className='font-[700]'>Landline:&nbsp;</span>
                                <span className='underline xs:decoration-1 underline-offset-[3px] decoration-white/50 font-[400]'>
                                    +254202214110
                                </span>
                            </a>
                        </div>
                        {/* <button
                            onClick={handleClick}
                            className='trns500 mt-[1.75rem] xs:mb-[1rem] lg:mb-0 bg-gradient-to-r from-primaryRichBlue to-primaryRichGreen group relative z-[1000] cursor-pointer flex items-center justify-center alata btnTxtSize tracking-[0px] text-white/90 hover:text-black xs:w-full xs:h-[3.25rem] xsp:h-[4rem] lg:h-[3rem] xl:h-[3.5rem] 2xl:h-[4rem] rounded-full mx-auto border-[3px] border-slate-200/80 hover:border-slate-200 shadow-2xl outline-[4px] outline-white/20 hover:outline-slate-900/80 btnTxtShadow'
                        >
                            Employee Sign-in
                            <GrGoogle className='trns500 absolute bg-white/20 group-hover:bg-slate-900 border-[2px] border-white/20 group-hover:border-slate-900/0 group-hover:text-white rounded-full xs:p-[0.55rem] lg:p-[0.6rem] xl:p-[0.7rem] xs:h-[2.25rem] xs:w-[2.25rem] md:h-[2.5rem] md:w-[2.5rem] lg:h-[2.75rem] lg:w-[2.75rem] xl:h-[2.75rem] xl:w-[2.75rem] xs:right-[0.3rem] md:right-[0.5rem] lg:right-[0.4rem] xl:right-[0.4rem] shadow-md' />
                        </button> */}
                    </div>
                </div>

                <div className="rightFtr flex flex-col xs:px-[1rem] lg:pl-[3rem] h-full z-[999] xs:mt-[1.85rem] xs:mb-[0rem] xs:pt-[0.25rem] lg:pt-0 lg:mt-0 xs:border-t lg:border-t-0 border-white/50">
                    <p
                        className='outfit flex flex-col ftrTxt tracking-[1px] my-[1rem] text-white items-center'
                    >
                        <span className='font-[700]'>Physical Address:</span>
                        <p>
                            Rehani House, 8<sup>th</sup> Floor Koinange Street, Nairobi, Kenya
                        </p>
                    </p>
                    <div
                        className='rounded-[12px] overflow-hidden shadow-2xl xs:h-[450px] lg:h-[250px] 2xl:h-[300px] xs:mb-[1.5rem] lg:mb-[3rem]'
                    >
                        <LoadScript googleMapsApiKey="AIzaSyCV9fDfomjaNaVvkKPkfAGcsC9M3nUUTyA">
                            <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={19}>
                                <Marker position={center} />
                            </GoogleMap>
                        </LoadScript>
                    </div>
                </div>
            </div>
            <p
                className='outfit font-[600] xs:w-[95%] lg:w-[80%] text-center uppercase xs:text-[0.45rem] xsp:text-[0.55rem] md:text-[0.6rem] lg:text-[0.5rem] xl:text-[0.525rem] 2xl:text-[0.6rem] tracking-[2px] text-white mb-[2rem] txtShadow border-t border-white/20 pt-[1.5rem]'
            >
                Copyright&copy; {new Date().getFullYear()}, Murage Juma & Company Advocates.
                <br />
                All rights reserved.
            </p>
            <div className="relative flex flex-col items-center justify-center w-full bg-primaryDarkerBlue border-t-[2px] border-blue-950 h-auto pb-[1.25rem] shadow-[inset_0px_12px_24px_rgba(0,0,0,0.5)]">
                <div className={`absolute top-0 left-0 bgPtn w-full h-full z-[100] mix-blend-color-burn`} />
                <div className={`absolute top-0 left-0 bgPtn w-full h-full z-[100] mix-blend-color-burn opacity-50`} />
                <div
                    className='flex flex-col items-center group'
                >
                    <a
                        href='https://markmutai.dev/'
                        target="_blank"
                        rel="noreferrer"
                    >
                        <img
                            src={mmLogo}
                            alt="Designed By Mutai"
                            className='cursor-pointer relative z-[999] xs:w-[3.25rem] xsp:w-[3.5rem] md:w-[4.75rem] lg:w-[3.25rem] xl:w-[3.5rem] 2xl:w-[4rem] xs:-mt-[1rem] md:-mt-[1.25rem] lg:-mt-[1rem]'
                        />
                    </a>
                    <a
                        href='https://markmutai.dev/'
                        target="_blank"
                        rel="noreferrer"
                        className='trns500 cursor-pointer uppercase outfit text-white text-center xs:tracking-[4px] lg:tracking-[5px] 2xl:tracking-[6px] xs:text-[0.425rem] xsp:text-[0.525rem] md:text-[0.6rem] lg:text-[0.45rem] xl:text-[0.475rem] 2xl:text-[0.5rem] z-[999] underline underline-offset-4 decoration-white/0 group-hover:decoration-white'
                    >
                        <p
                        // className='whitespace-nowrap'
                        >
                            Designed by Mutai
                        </p>
                        {/* <p
                            className='whitespace-nowrap -mt-[0.15rem]'
                        >
                            {new Date().getFullYear()}
                        </p> */}
                    </a>
                </div>
            </div>
            {/*   */}
            {/* <div className='w-full h-[1px] bg-gradient-to-l from-slate-800/0 to-slate-800/40 xs:mx-[1rem] lg:mx-[3rem]' /> */}
        </div>
    )
}

export default Ftr